export default [
  {
    path: '/drivers/shifts',
    name: 'drivers-shifts',
    component: () => import('@/views/driver/shifts/DriversShifts.vue'),
    meta: {
      resource: 'driver-inactivations',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Drivers Shifts',
      breadcrumb: [
        {
          text: 'Drivers Shifts',
          active: true,
        },
      ],
    },
  },
  {
    path: '/drivers/shifts/create',
    name: 'drivers-shifts-create',
    component: () => import('@/views/driver/shifts/ShiftForm.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Create Shift',
      breadcrumb: [
        {
          text: 'Drivers Shifts',
          to: '/drivers/shifts',
        },
        {
          text: 'Create Shift',
          active: true,
        },
      ],
    },
  },
  {
    path: '/drivers/shifts/edit/:id',
    name: 'drivers-shifts-edit',
    component: () => import('@/views/driver/shifts/ShiftForm.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Edit Shift',
      breadcrumb: [
        {
          text: 'Drivers Shifts',
          to: '/drivers/shifts',
        },
        {
          text: 'Edit Shift',
          active: true,
        },
      ],
    },
  },
  {
    path: '/drivers/learning-center',
    name: 'drivers-learning-center',
    component: () => import('@/views/driver/learning-center/List.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'learning-center-management',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Learning Center Management',
      breadcrumb: [
        {
          text: 'Learning Center Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/drivers/learning-center/new',
    name: 'drivers-learning-center-new',
    component: () => import('@/views/driver/learning-center/CreateNewLearning.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'learning-center-management',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Learning',
      breadcrumb: [
        {
          text: 'Learning Center Management',
          to: '/drivers/learning-center',
        },
      ],
    },
  },
  {
    path: '/drivers/learning-center/:id',
    name: 'drivers-learning-center-edit',
    component: () => import('@/views/driver/learning-center/EditLearning.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'learning-center-management',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Learning',
      breadcrumb: [
        {
          text: 'Learning Center Management',
          to: '/drivers/learning-center',
        },
      ],
    },
  },
  {
    path: '/drivers',
    name: 'drivers-list',
    component: () => import('@/views/driver/drivers-list/DriversList.vue'),
    meta: {
      allowedCountries: ['LY'],
      resource: 'verified-drivers',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Drivers',
      breadcrumb: [
        {
          text: 'Drivers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/drivers/location',
    name: 'drivers-location',
    component: () => import('@/views/driver/location/index.vue'),
    meta: {
      resource: 'drivers-location',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Drivers Location',
      breadcrumb: [
        {
          text: 'Drivers',
          to: '/drivers',
        },
      ],
    },
  },
  {
    path: '/drivers/blocked',
    name: 'blocked-drivers-list',
    component: () => import('@/views/driver/BlockedDrivers.vue'),
    meta: {
      resource: 'blocked-drivers',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Blocked Drivers',
      breadcrumb: [
        {
          text: 'Blocked Drivers',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/drivers/registration-repots',
    name: 'drivers-registration-reports',
    component: () => import('@/views/driver/registration-reports/index.vue'),
    meta: {
      resource: 'drivers-registration-reports',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Registration Reports',
      breadcrumb: [
        {
          text: 'Registration Reports',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/drivers-unverefied',
    name: 'unverified-drivers-list',
    component: () => import('@/views/driver/unverified/UnverefiedDrivers.vue'),
    meta: {
      resource: 'unverified-drivers',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Unverified Drivers',
      breadcrumb: [
        {
          text: 'Unverified Drivers',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/get-otp',
    name: 'get-driver-otp',
    component: () => import('@/views/driver/OTP/GetOTP.vue'),
    meta: {
      resource: 'get-otp-drivers',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Get OTP',
      breadcrumb: [
        {
          text: 'Get OTP',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/drivers/:id',
    name: 'drivers-view',
    component: () => import('@/views/driver/drivers-view/DriverView.vue'),
    meta: {
      resource: 'drivers',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Driver Details',
      breadcrumb: [
        {
          text: 'Drivers',
          to: '/drivers',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/drivers/new',
    name: 'drivers-new',
    component: () => import('@/views/driver/drivers-new/DriversNew.vue'),
    meta: {
      resource: 'drivers',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Driver',
      breadcrumb: [
        {
          text: 'Drivers',
          to: '/drivers',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/drivers/edit/:id',
    name: 'drivers-edit',
    component: () => import('@/views/driver/drivers-edit/DriversEdit.vue'),
    meta: {
      resource: 'drivers',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Driver',
      breadcrumb: [
        {
          text: 'Drivers',
          to: '/drivers',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/violations',
    name: 'violations',
    component: () => import('@/views/driver/violations-types/Index.vue'),
    meta: {
      resource: 'violations',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Violations Management',
      breadcrumb: [
        {
          text: 'Violations Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/violations/new',
    name: 'new-violations',
    component: () => import('@/views/driver/violations-types/CreateViolation.vue'),
    meta: {
      resource: 'violations',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Create Violation',
      breadcrumb: [
        {
          text: 'Violations Management',
          to: '/violations',
        },
      ],
    },
  },
  {
    path: '/liveness-check',
    name: 'liveness-check-list',
    component: () => import('@/views/driver/liveness-check/LivenessCheckList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Driver Liveness Check',
      breadcrumb: [
        {
          text: 'Driver Liveness Check',
          active: true,
        },
      ],
    },
  },
  {
    path: '/liveness-check/:id',
    name: 'liveness-check-view',
    component: () => import('@/views/driver/liveness-check/LivenessCheckView.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Liveness Check Details',
      breadcrumb: [
        {
          text: 'Driver Liveness Check',
          to: '/liveness-check',
        },
        {
          text: 'Details',
          active: true,
        },
      ],
    },
  },
  {
    path: '/violations/:id',
    name: 'violations-edit',
    component: () => import('@/views/driver/violations-types/EditViolation.vue'),
    meta: {
      resource: 'violations',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Violations Management',
      breadcrumb: [
        {
          text: 'Violations Management',
          to: '/violations',
        },
      ],
    },
  },
  {
    path: '/drivers/violations/list',
    name: 'drivers-violations-list',
    component: () => import('@/views/driver/violations/Index.vue'),
    meta: {
      resource: 'drivers-violations',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Violations Management',
      breadcrumb: [
        {
          text: 'Violations Management',
          to: '/violations',
        },
      ],
    },
  },
 
]
